/**
 * Afișare corectă a mărcilor auto în UI/SEO.
 * Evită bug-uri de tip „Bmw", „Mg", „Bmw X5" generate de capitalizarea naivă a slug-urilor.
 */

const ACRONYMS: Record<string, string> = {
  bmw: 'BMW',
  vw: 'VW',
  mg: 'MG',
  ds: 'DS',
  gmc: 'GMC',
  ram: 'RAM',
  byd: 'BYD',
  seat: 'SEAT',
  smart: 'smart',
  bmwi: 'BMW i',
  mini: 'MINI',
  jac: 'JAC',
  faw: 'FAW',
  saic: 'SAIC',
  kgm: 'KGM',
  suv: 'SUV',
};

const SPECIAL: Record<string, string> = {
  'mercedes-benz': 'Mercedes-Benz',
  'mercedes benz': 'Mercedes-Benz',
  'alfa-romeo': 'Alfa Romeo',
  'alfa romeo': 'Alfa Romeo',
  'land-rover': 'Land Rover',
  'land rover': 'Land Rover',
  'rolls-royce': 'Rolls-Royce',
  'aston-martin': 'Aston Martin',
  'great-wall': 'Great Wall',
  'ssangyong': 'SsangYong',
  'citroen': 'Citroën',
  'skoda': 'Škoda',
  'mclaren': 'McLaren',
};

/** Formatează numele unei mărci pentru afișare (ex: "bmw" → "BMW", "mercedes-benz" → "Mercedes-Benz"). */
export function formatMakeDisplay(raw?: string | null): string {
  if (!raw) return '';
  const value = raw.trim();
  const key = value.toLowerCase();

  if (SPECIAL[key]) return SPECIAL[key];
  if (ACRONYMS[key]) return ACRONYMS[key];

  return value
    .split(/([\s-])/)
    .map((part) => {
      if (part === ' ' || part === '-') return part;
      const lower = part.toLowerCase();
      if (ACRONYMS[lower]) return ACRONYMS[lower];
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join('');
}

/** Formatează numele unui model (păstrează acronime uzuale gen GLE, X5, ID.4). */
export function formatModelDisplay(raw?: string | null): string {
  if (!raw) return '';
  return raw
    .trim()
    .split(/([\s-])/)
    .map((part) => {
      if (part === ' ' || part === '-') return part;
      if (part.length <= 3) return part.toUpperCase();
      const lower = part.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join('');
}
